import styled from 'styled-components'

export const PageTemplateWrapper = styled.main`
  min-height: 100vh;
`
